export const vasChargeType = {
  UNION: 'UNION',
  MHE: 'MHE',
  DEDICATED: 'DEDICATED_VEHICLE'
};

export const locationTypeOptions = [
  {
    key: 'CWH',
    value: 'CWH'
  },
  {
    key: 'RIVIGO',
    value: 'Rivigo Location'
  }
];

export const entityTypeOptions = [
  {
    key: 'PRS',
    val: 'PRS'
  },
  {
    key: 'TRIP',
    val: 'TRIP'
  },
  {
    key: 'DRS',
    val: 'DRS'
  }
];

export const entityTypeOptionsDedicatedVehicle = [
  {
    key: 'PRS',
    val: 'PRS'
  },
  {
    key: 'DRS',
    val: 'DRS'
  }
];

export const chargeBasisOptions = [
  {
    key: 'RATE_PER_CN',
    val: 'RATE PER CN'
  },
  {
    key: 'RATE_PER_BOX',
    val: 'RATE PER BOX'
  },
  {
    key: 'LUMPSUM_AMOUNT',
    val: 'LUMPSUM AMOUNT'
  }
];

export const chargeBasisOptionsDedicatedVehicle = [
  {
    key: 'LUMPSUM_AMOUNT',
    val: 'LUMPSUM AMOUNT'
  }
];

export const activityTypeOptions = [
  {
    key: 'LOADING',
    val: 'LOADING'
  },
  {
    key: 'UNLOADING',
    val: 'UNLOADING'
  }
];
